<!-- Mode 1: Request activation email -->
<form
  class="form-signin verify"
  [formGroup]="requestForm"
  *ngIf="mode === 'request' && requestForm"
  (ngSubmit)="onSubmitRequest($event)"
  autocomplete="off"
>
  <h4>Activer mon compte</h4>
  <div
    class="alert"
    style="font-size: 0.8em; padding: 10px; background-color: #e8f5e9; border: 1px solid #009145; color: #333;"
  >
    Renseignez votre adresse email. Vous recevrez un email
    permettant l'activation de votre compte.
  </div>

  <input
    type="text"
    class="form-control"
    name="pseudo"
    formControlName="username"
    placeholder="Email"
    required
    autofocus
    [ngClass]="{ 'is-invalid': submitted && rf.username.errors }"
  />
  <div *ngIf="submitted && rf.username.errors" class="invalid-feedback">
    <div *ngIf="rf.username.errors.required">Email requis.</div>
  </div>

  <!-- Message de succès si compte déjà activé -->
  <div *ngIf="isAlreadyActive" class="alert alert-success mt-3 mb-0" style="font-size: 0.9em; padding: 10px;">
    <i class="fas fa-check-circle"></i> {{ error }}
    <div class="col-12 text-center pt-3">
      <button class="btn btn-success" type="button" (click)="goToLogin()">
        <i class="fas fa-sign-in-alt"></i> Me connecter
      </button>
    </div>
  </div>

  <!-- Message d'erreur (sauf si déjà activé) -->
  <div *ngIf="error && !isAlreadyActive" class="alert alert-danger mt-3 mb-0" style="font-size: 0.9em; padding: 10px;">
    <i class="fas fa-exclamation-triangle"></i> {{ error }}
  </div>

  <div class="col-12 text-center pt-4" *ngIf="!isAlreadyActive">
    <button class="btn btn-success" type="submit" [disabled]="loading">
      <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>&nbsp;<i
        class="fas fa-envelope"
      ></i>
      Envoyer le lien d'activation
    </button>
  </div>

  <div
    class="alert mt-3 mb-0"
    style="font-size: 0.8em; padding: 10px; cursor: pointer; background-color: #e8f5e9; border: 1px solid #009145; color: #333;"
    (click)="goToLogin()"
    *ngIf="!isAlreadyActive"
  >
    Vous avez déjà un compte activé ? <strong>Cliquez-ici</strong>
  </div>

  <div class="col-12 text-center pt-4">
    <button class="btn" type="button" (click)="goBack()" style="background-color: #1f519e; color: white;">
      <i class="fa fa-chevron-left"></i> Retour
    </button>
  </div>
</form>

<!-- Mode 2: Activation confirmation (token present) -->
<div class="form-signin verify" *ngIf="mode === 'activate'">
  <h4>Activation du compte</h4>

  <!-- Loading state -->
  <div *ngIf="loading" class="text-center py-4">
    <i class="fas fa-spinner fa-spin fa-2x"></i>
    <p class="mt-3">Vérification en cours...</p>
  </div>

  <!-- Token valid - show activation button -->
  <ng-container *ngIf="!loading && user && !error">
    <div
      class="alert alert-success"
      style="font-size: 0.9em; padding: 10px;"
    >
      <i class="fas fa-check-circle"></i>
      Bonjour <strong>{{ user.prenom }} {{ user.nom }}</strong>,<br>
      Cliquez sur le bouton ci-dessous pour activer votre compte.
    </div>

    <div class="col-12 text-center pt-4">
      <button class="btn btn-success btn-lg" type="button" (click)="onActivate()" [disabled]="loading">
        <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>
        <i class="fas fa-check" *ngIf="!loading"></i>
        Activer mon compte
      </button>
    </div>
  </ng-container>

  <!-- Success state - après activation réussie -->
  <ng-container *ngIf="!loading && success">
    <div class="alert alert-success" style="font-size: 0.9em; padding: 10px;">
      <i class="fas fa-check-circle"></i> {{ success }}
    </div>

    <div class="col-12 text-center pt-3">
      <button class="btn btn-success" type="button" (click)="goToLogin()">
        <i class="fas fa-sign-in-alt"></i> Me connecter
      </button>
    </div>
  </ng-container>

  <!-- Error state -->
  <ng-container *ngIf="!loading && error && !success">
    <div class="alert alert-danger" style="font-size: 0.9em; padding: 10px;">
      <i class="fas fa-exclamation-triangle"></i> {{ error }}
    </div>

    <div class="col-12 text-center pt-3">
      <button class="btn btn-success" type="button" (click)="goToLogin()">
        <i class="fas fa-sign-in-alt"></i> Me connecter
      </button>
    </div>
  </ng-container>

  <div
    class="alert mt-3 mb-0"
    style="font-size: 0.8em; padding: 10px; cursor: pointer; background-color: #e8f5e9; border: 1px solid #009145; color: #333;"
    (click)="goToSignin()"
    *ngIf="!loading && !user && !error && !success"
  >
    Pas encore de compte ? <strong>Créer un compte</strong>
  </div>

  <div class="col-12 text-center pt-4">
    <button class="btn" type="button" (click)="goBack()" style="background-color: #1f519e; color: white;">
      <i class="fa fa-chevron-left"></i> Retour
    </button>
  </div>
</div>
